module.exports = __webpack_public_path__ + "static/media/YF84_8.4e41dc0b.jpg";